import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { colors } from '../constants';

const Boxed = styled(Link)`
  display: inline-block;
  background: ${colors.primary};
  color: white;
  padding: 4px 16px;
  font-weight: bold;
  &:hover,
  &:focus {
    background: ${colors.primaryDark};
    text-decoration: none;
  }
  @media print {
    display: none;
  }
`;

const BoxedSecondary = styled(Boxed)`
  background: ${colors.secondary};
  &:hover,
  &:focus {
    background: ${colors.secondaryDark};
  }
  @media print {
    display: none;
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-left: 12px;
`;

const IconLeft = styled(FontAwesomeIcon)`
  margin-right: 12px;
`;

function BoxedLink({ to, back, children }) {
  const BoxedComponent = back ? BoxedSecondary : Boxed;
  return back ? (
    <BoxedSecondary to={to}>
      <IconLeft icon={faArrowLeft} color="#fff" />
      {children}
    </BoxedSecondary>
  ) : (
    <BoxedComponent to={to}>
      {children}
      <Icon icon={faArrowRight} color="#fff" />
    </BoxedComponent>
  );
}

export default BoxedLink;
